module.exports = ".modal-body {\n    max-height: 400px;\n    overflow: auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/denuncias/denuncias.component.css
// module id = ./src/app/denuncias/denuncias.component.css
// module chunks = main